import React from 'react';
import '../styles.css';
import AppBar from '../components/AppBar.js';
import VerificationList from '../components/verification/VerificationList.js';

function VerificationPage() {
    return (
        <div>
            <AppBar backTo='' displayText="Home" />
            <VerificationList />
        </div>
    )
}

export default VerificationPage;
